(function() {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) return;

  // Mappings for cases where main store name != Candy Rack option text
  const MODEL_MAP = {
    'iPhone 12': 'iPhone 12 / 12 Pro',
    'iPhone 12 Pro': 'iPhone 12 / 12 Pro'
  };

  // Known placeholder variant IDs (the "Choose Your Model" defaults)
  const PLACEHOLDER_IDS = ['41728994803765'];

  function getCurrentModel() {
    const span = document.querySelector('[id$="-selected-value"]');
    if (span && span.textContent.trim()) return span.textContent.trim();
    const checked = document.querySelector('input[type="radio"][data-option-position="1"]:checked');
    if (checked) {
      const label = checked.closest('label');
      return (label && label.textContent.trim()) || checked.dataset.optionName;
    }
    return null;
  }

  // ============ VISUAL UPDATE ============
  function updateVisibleLabels() {
    try {
      const model = getCurrentModel();
      if (!model) return;
      const target = MODEL_MAP[model] || model;

      document.querySelectorAll('select.candyrack-ppp-select-input').forEach(function(select) {
        const isModelSelect = [...select.options].some(opt => /^(iPhone|Samsung)/i.test(opt.textContent));
        if (!isModelSelect) return;

        const hasMatch = [...select.options].some(opt => opt.textContent.trim() === target);
        if (!hasMatch) return;

        const wrapper = select.closest('[class*="selectWrapper"]');
        const label = wrapper && wrapper.querySelector('[class*="selectHandleLabel"]');
        if (label) label.textContent = target;
      });
    } catch (err) { console.warn('[CR visual]', err); }
  }

  function bumpVisual() {
    [50, 300, 800, 1500].forEach(d => setTimeout(updateVisibleLabels, d));
  }

  // ============ CART INTERCEPTION ============
  function buildVariantGroups() {
    const groups = [];
    const variantToGroup = new Map();
    document.querySelectorAll('select.candyrack-ppp-select-input').forEach((select, i) => {
      const isModelSelect = [...select.options].some(opt => /^(iPhone|Samsung)/i.test(opt.textContent));
      if (!isModelSelect) return;
      const modelToVariant = {};
      [...select.options].forEach(opt => {
        const text = opt.textContent.trim();
        const id = String(opt.value);
        variantToGroup.set(id, i);
        if (/^(iPhone|Samsung)/i.test(text)) modelToVariant[text] = id;
      });
      groups[i] = modelToVariant;
    });
    return { groups, variantToGroup };
  }

  function fixVariantId(originalId, model) {
    const { groups, variantToGroup } = buildVariantGroups();
    const groupIndex = variantToGroup.get(String(originalId));
    if (groupIndex === undefined) return null;
    const group = groups[groupIndex];
    const target = MODEL_MAP[model] || model;
    const fixedId = group[target];
    if (!fixedId || fixedId === String(originalId)) return null;
    return fixedId;
  }

  function rewriteBody(body, model) {
    if (typeof body !== 'string') return { body: body, changed: false };
    let parsed;
    try { parsed = JSON.parse(body); } catch (e) { return { body: body, changed: false }; }

    let changed = false;
    if (Array.isArray(parsed.items)) {
      parsed.items = parsed.items.map(function(item) {
        const fixed = fixVariantId(item.id, model);
        if (fixed) {
          console.log('[CR fix]', item.id, '->', fixed, '(' + model + ')');
          changed = true;
          return Object.assign({}, item, { id: parseInt(fixed, 10) });
        }
        return item;
      });

      if (!changed) {
        parsed.items.forEach(function(item) {
          if (PLACEHOLDER_IDS.includes(String(item.id))) {
            console.error('[CR MISSED]', item.id, 'model was:', model);
          }
        });
      }
    } else if (parsed.id) {
      const fixed = fixVariantId(parsed.id, model);
      if (fixed) {
        console.log('[CR fix]', parsed.id, '->', fixed, '(' + model + ')');
        parsed.id = parseInt(fixed, 10);
        changed = true;
      } else if (PLACEHOLDER_IDS.includes(String(parsed.id))) {
        console.error('[CR MISSED]', parsed.id, 'model was:', model);
      }
    }
    return { body: changed ? JSON.stringify(parsed) : body, changed: changed };
  }

  // Intercept fetch
  const origFetch = window.fetch;
  window.fetch = function(input, init) {
    try {
      const url = typeof input === 'string' ? input : (input && input.url);
      if (url && /\/cart\/(add|change|update)/.test(url) && init && init.body) {
        const model = getCurrentModel();
        if (model) {
          const result = rewriteBody(init.body, model);
          if (result.changed) init = Object.assign({}, init, { body: result.body });
        }
      }
    } catch (err) { console.warn('[CR intercept fetch]', err); }
    return origFetch.call(this, input, init);
  };

  // Intercept XHR
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._crUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(body) {
    try {
      if (this._crUrl && /\/cart\/(add|change|update)/.test(this._crUrl)) {
        const model = getCurrentModel();
        if (model) {
          const result = rewriteBody(body, model);
          if (result.changed) body = result.body;
        }
      }
    } catch (err) { console.warn('[CR intercept xhr]', err); }
    return origSend.call(this, body);
  };

  // Listen for any uncaught errors from our code
  window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('CR ')) {
      console.error('[CR critical]', e);
    }
  });

  // ============ INIT ============
  function init(attempts) {
    attempts = attempts || 0;
    if (!document.querySelector('select.candyrack-ppp-select-input')) {
      if (attempts > 60) return;
      return setTimeout(function() { init(attempts + 1); }, 300);
    }

    // Pulse visual updates during the first few seconds to catch late mounts
    [0, 100, 300, 600, 1000, 1500, 2500].forEach(d => setTimeout(updateVisibleLabels, d));

    document.addEventListener('change', function(e) {
      if (e.target.matches && e.target.matches('input[type="radio"][data-option-position="1"]')) {
        bumpVisual();
      }
    });

    const span = document.querySelector('[id$="-selected-value"]');
    if (span) {
      new MutationObserver(bumpVisual).observe(span, {
        childList: true, characterData: true, subtree: true
      });
    }

    // Catch Candy Rack mounting/remounting selects after init
    new MutationObserver(function(mutations) {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && (
            (node.matches && node.matches('select.candyrack-ppp-select-input')) ||
            (node.querySelector && node.querySelector('select.candyrack-ppp-select-input'))
          )) {
            bumpVisual();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }

  console.log('[CR intercept] active');
})();